import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";

type SizingRecommendationBadgeProps = {
  recommendation: "runs_large" | "runs_small" | null;
};

export function SizingRecommendationBadge({
  recommendation,
}: SizingRecommendationBadgeProps) {
  const t = useTranslation();

  if (!recommendation) return null;

  if (recommendation === "runs_large") {
    return <Badge variant="warning">{t("sizing.runsLarge")}</Badge>;
  }

  return <Badge variant="default">{t("sizing.runsSmall")}</Badge>;
}
